import { getConditionalObject } from 'utils/data';

export const tableBodyStyles = {
  '& .table-cell': {
    padding: '4px 24px 4px',
    borderColor: ({ palette }) => `${palette.border.default} !important`,
    color: ({ palette }) => palette.text.secondary,
    fontSize: '1.4rem',
    fontWeight: 400,
    lineHeight: '2.2rem',
    '&:first-of-type': {
      width: '199px',
      paddingRight: '12px',
    },
    '&:not(:first-of-type)': {
      width: '118px',
      paddingLeft: '0px',
      '& p': {
        fontWeight: '600',
        fontSize: '1.8rem !important',
        lineHeight: '2.8rem !important',
      },
    },
  },

  '& .table-row:last-of-type .table-cell': {
    border: 'none',
  },
};

export const footerCellStyles = {
  '&:first-of-type': {
    width: '151px',
  },
  '&:not(:first-of-type)': {
    width: '142px',
    color: ({ palette }) => `${palette.primary.main}`,
    '& p': {
      fontWeight: '600',
      fontSize: '1.8rem !important',
      lineHeight: '2.8rem !important',
    },
  },
};

export const tableContainerStyles = {
  border: '1px solid',
  borderColor: ({ palette }) => `${palette.border.default}`,
  borderRadius: '8px',
};

export const footerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: '12px',
  fontSize: '1.8rem',
  fontWeight: 500,
  lineHeight: '1.8rem',
  color: ({ palette }) => palette.text.primary,
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderRadius: '8px',
};

export const commonPendingChangesStyles = {
  float: 'right',
};

export const getTableCellPendingChangesStyles = ({ isModified }) => ({
  ...commonPendingChangesStyles,
  ...getConditionalObject(isModified, {
    marginRight: '-4px',
  }),
});
